/* eslint-disable no-param-reassign */
const cleanUpObject = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === '' || obj[key] === undefined) {
      delete obj[key];
    }
  });
};

export default cleanUpObject;
